let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3UKtX")).then(() => parcelRequire('4mTJs'));